import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Person } from '@sdir/httpclient/lib/clients/core/externallookup';
import { styles } from '@sdir/sds';
import { CurrentUser } from '@sdir/auth/lib/types';

interface TopSectionProps {
  person: null | Person;
  heading?: string;
  isExternal?: boolean;
  currentUser?: CurrentUser;
}

const TopSection: React.FC<TopSectionProps> = ({ person, heading, isExternal, currentUser }) => {
  const intl = useIntl();
  const name = `${`${person?.firstName || ''} ${person?.middleName || ''} ${
    person?.lastName || ''
  }`}`;
  const email = currentUser?.profile?.email || currentUser?.profile?.name || '-';

  return (
    <>
      <H2>
        {heading ||
          intl.formatMessage({
            id: 'contactinfo.title',
          })}
      </H2>
      {isExternal ? (
        <>
          <NameSubHeader>{intl.formatMessage({ id: 'contactinfo.email' })}</NameSubHeader>
          <BoldText>{email}</BoldText>
        </>
      ) : (
        <>
          <NameSubHeader>{intl.formatMessage({ id: 'contactinfo.navn' })}</NameSubHeader>
          <BoldText>
            {name.trim() !== '' ? name : intl.formatMessage({ id: 'general.error.no.results' })}
          </BoldText>
        </>
      )}
    </>
  );
};

export default TopSection;

const H2 = styled.h2``;

const BoldText = styled.p`
  font-weight: bold;
  margin-top: auto;
`;

const NameSubHeader = styled(BoldText)`
  font-size: 1.75rem;
  color: ${styles.colors.font.textTable};
  margin-bottom: 0.5rem;
`;
